<template>
  <span v-show="!!text" :color="color" label class="cursor-pointer subheading my-1 mx-2 px-2 incidencia-chip border border-dense"
        @click="copy"
  >
    {{ text }}
  </span>
</template>

<script>
export default {
  name: 'CopyChip',
  props: {
    text: { type: String, default: null },
    color: { type: String, default: '' }
  },
  data () { return { textCopied: '¡Copiado!' } },
  methods: {
    copy (event) {
      if (event.target.childNodes[0] && event.target.childNodes[0].textContent.trim() !== this.textCopied) {
        const selection = window.getSelection()
        const range = document.createRange()
        event.target.textContent = event.target.textContent.trim()
        range.selectNodeContents(event.target)
        selection.removeAllRanges()
        selection.addRange(range)
        try {
          document.execCommand('copy')
          selection.removeAllRanges()
          const original = event.target.textContent
          event.target.textContent = this.textCopied
          setTimeout(() => {
            event.target.textContent = original
          }, 1300)
        } catch (e) { }
      }
    }
  }
}
</script>

<style>
/* .incidencia-chip {
  height: 28px;
} */
.incidencia-chip:hover {
  font-weight: 500;
}
.incidencia-chip .v-chip__content {
  min-height: unset;
  height: auto;
  font-size: 1rem;
}
.incidencia-chip .q-icon {
  height: unset;
  min-width: unset;
  font-size: 2px;
}
</style>
